export default __webpack_public_path__ + "static/media/find-by-email.d3113968.svg";